import { useReducer } from 'react';
import Reducer from './reducer';
import { Actions } from './actions';
import {
	getProjectOverviewDetailsApi,
	getOverviewVendorDetailsApi,
} from '../../views/feature/Projects/ProjectsOverview/GraphQlApis';
import {requestExecutor} from "../../controllers/ApiFunctions/index"
export const ProjectOverviewState = (props) => {
	const intialState = {
		projectVendorDetails: null,
		projectEventDetails: null,
	};

	const [state, dispatch] = useReducer(Reducer, intialState);

	const getALlProjectDetails = async (json, vendorId) => {
		const { success, result } = await requestExecutor(
			getProjectOverviewDetailsApi,
			json,
			vendorId,
		);
		if (success) {
			dispatch({
				type: Actions.GET_PROJECT_RELATED_DATA_SUCCESS,
				payload: result,
			});
		} else {
			dispatch({
				type: Actions.GET_PROJECT_RELATED_DATA_FAILED,
				payload: result,
			});
		}
	};

	const getAllVendorsEventDetails = async (json, vendorId) => {
		const { success, result } = await requestExecutor(
			getOverviewVendorDetailsApi,
			json,
			vendorId,
		);

		if (success) {
			dispatch({
				type: Actions.GET_ALL_VENDER_LIST_DATA_SUCCESS,
				payload: result,
			});
		} else {
			dispatch({
				type: Actions.GET_ALL_VENDER_LIST_DATA_FAILED,
				payload: result,
			});
		}
	};

	return {
		...state,
		getALlProjectDetails,
		getAllVendorsEventDetails,
	};
};
